import React from 'react';

// Document Analysis Indicator Component
const DocumentAnalysisIndicator = ({ message }) => {
  const progress = message?.analysisProgress || 0;
  const status = message?.analysisStatus || 'Analyzing document...';
  
  return (
    <div className="search-indicator-container">
      <div className="search-indicator-header">
        <div className="search-indicator-main">
          {/* Icon */}
          <div className="analysis-icon-container">
            <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          
          {/* Status text */}
          <span className="search-status-text">
            {status}
          </span>
          
          {/* Loading dots */}
          <div className="search-dots">
            <div className="search-dot"></div>
            <div className="search-dot"></div>
            <div className="search-dot"></div>
          </div>
        </div>
      </div>
      
      {/* Progress bar */}
      {progress > 0 && (
        <div className="mt-2 w-full bg-gray-200 dark:bg-[#2a2a2a] rounded-full h-1">
          <div 
            className="bg-blue-500 dark:bg-blue-400 h-1 rounded-full transition-all duration-300"
            style={{ width: `${Math.min(100, progress)}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default DocumentAnalysisIndicator; 